// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"96591b1e","1922":"96591b1e","3166":"96591b1e","4774":"96591b1e","5291":"96591b1e","5858":"96591b1e","8614":"96591b1e","9226":"96591b1e","9686":"5f49bcae"}[chunkId] + ".chunk.css";
};